import { Component, OnInit, asNativeElements } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl, FormsModule } from '@angular/forms';
import { NotificationsService } from "angular2-notifications";
import { Router } from '@angular/router';
import { ActivatedRoute, Params } from '@angular/router';
import { CrudService } from './../../../crud/crud.service';

import { Mensaje } from '../../../mensaje';

@Component({
  selector: 'app-grupo-formulario',
  templateUrl: './formulario.component.html'
})

export class FormularioComponent implements OnInit{
  dato: FormGroup;
  form_practicas_materias;
  tieneid;
  materias;
  materias_anteriores = [];
  tamano = document.body.clientHeight;

  color = [];
  respuesta: any[] = [];
  mensajeResponse: Mensaje = new Mensaje(true);
  constructor(private route: ActivatedRoute, private router: Router, private crud: CrudService, private fb: FormBuilder, private notificacion: NotificationsService) { }
  ngOnInit() {
    this.dato = this.fb.group({
      id: [''],
      nombre: ['', [Validators.required]],
      categorias_id: [''],
      carreras_planes_id: [''],
      materias_id: [''],
      causa_reprobacion: ['1'],
      porcentaje_valor: [20, [Validators.required]],
      imprimible_boleta: ['0'],
      imprimible_alumno: ['1'],
      es_practica: ['1'],
      nivel: [1, [Validators.required]],
      clave: [''],
      hd: [0],
      hi: [0],
      creditos: [],
      orden: [0],
      practicas_materias: this.fb.array([])
    });

    this.form_practicas_materias = {
      id: [''],
      nombre: ['', [Validators.required]],
      practicas: this.fb.array([]),
      materias: this.fb.array([]),
      practicas_id: ['', [Validators.required]],
      materias_id: ['', [Validators.required]]
    };

    this.route.params.subscribe(params => {
      this.tieneid = params['id'];
    });
    //Solo si se va a cargar catalogos poner un <a id="catalogos" (click)="ctl.cargarCatalogo('modelo','ruta')">refresh</a>
    document.getElementById("catalogos").click();
  }
  parametros = {
    pagina: 0,
    limite: 0
  };
  filtrar(){
    this.materias = [];
    this.dato.controls.materias_id.patchValue('');
    let cp = this.dato.controls.carreras_planes_id.value;
    if (cp!=null && cp!='') {
      this.crud.lista(this.parametros, 'materia?carreras_planes_id='+cp+'&nivel='+this.dato.controls.nivel.value).subscribe(
        resultado => {
            this.materias = resultado.data;
        },
        error => {
        }
      );
    }
  }

  agregar_form_array(modelo, formulario) {

    if (this.dato.controls.materias_id.value!=null && this.dato.controls.materias_id.value!="") {
      let repetido = false;
      this.dato.controls.practicas_materias.value.forEach(materia => {
        console.log(materia.id,this.dato.controls.materias_id.value)
        if (materia.materias_id==this.dato.controls.materias_id.value) {
          repetido = true;
          return false;
        }
      });


      let nombre =  '';

      if(!repetido){
        this.materias.forEach(element => {
          if(element.id==this.dato.controls.materias_id.value){
            nombre =  'Nivel: '+element.nivel+' / '+element.clave+' / '+element.nombre;
          }
        });

        (<FormArray>modelo).push(this.fb.group(
          {
            id: [''],
            nombre: [nombre, [Validators.required]],
            practicas_id: [''],
            materias_id: [this.dato.controls.materias_id.value, [Validators.required]]
          }
        ));

      } else {
        this.mensajeResponse.titulo = "Validación de Materias";
        this.mensajeResponse.texto = "Ya habías agregado esa materia";
        this.mensajeResponse.mostrar = true;
        this.mensajeResponse.clase = 'warning';

        this.mensaje(3);
      }
    } else {
      this.mensajeResponse.titulo = "Validación de Materias";
      this.mensajeResponse.texto = "Seleccione una materia para agregar";
      this.mensajeResponse.mostrar = true;
      this.mensajeResponse.clase = 'warning';

      this.mensaje(3);
    }
  }

  quitar_form_array(modelo, i: number) {
    modelo.removeAt(i);
  }


  public options = {
    position: ["bottom", "left"],
    timeOut: 2000,
    lastOnBottom: true
  };


  mensaje(cuentaAtras: number = 6, posicion: any[] = ["bottom", "left"]): void {
    let objeto = {
      showProgressBar: true,
      pauseOnHover: false,
      clickToClose: true,
      maxLength: this.mensajeResponse.texto.length
    };

    this.options = {
      position: posicion,
      timeOut: cuentaAtras * 1000,
      lastOnBottom: true
    };
    if (this.mensajeResponse.clase == 'alert')
      this.notificacion.alert(this.mensajeResponse.titulo, this.mensajeResponse.texto, objeto);

    if (this.mensajeResponse.clase == 'success')
      this.notificacion.success(this.mensajeResponse.titulo, this.mensajeResponse.texto, objeto);

    if (this.mensajeResponse.clase == 'info')
      this.notificacion.info(this.mensajeResponse.titulo, this.mensajeResponse.texto, objeto);

    if (this.mensajeResponse.clase == 'warning' || this.mensajeResponse.clase == 'warn')
      this.notificacion.warn(this.mensajeResponse.titulo, this.mensajeResponse.texto, objeto);

    if (this.mensajeResponse.clase == 'error' || this.mensajeResponse.clase == 'danger')
      this.notificacion.error(this.mensajeResponse.titulo, this.mensajeResponse.texto, objeto);

  }

}
